import { jsx as _jsx } from "react/jsx-runtime";
import { useRouter } from "next/router";
import React, { useRef } from "react";
import { login, useAuth } from "./auth";
import { getPublicRuntimeConfig } from "./utils/runtime-config";
export const ProtectedApp = ({ accessRedirect, ignoreAccess = false, children, }) => {
    const { user, isLoading } = useAuth();
    const router = useRouter();
    const { DTN_PRODUCT_CODE } = getPublicRuntimeConfig();
    const isRedirecting = useRef(false);
    // pages that should be accessible to everyone (without authorization)
    const publicPages = ["/unauthorized"];
    const isPublicPage = publicPages.includes(router.pathname);
    if (!isLoading) {
        if (!user) {
            if (!isRedirecting.current) {
                isRedirecting.current = true;
                login(router.basePath);
            }
            return null;
        }
        if (isPublicPage) {
            return _jsx(React.Fragment, { children: children });
        }
        const hasAppAccess = DTN_PRODUCT_CODE !== undefined && user.availableApps.length > 0
            ? user.availableApps.includes(DTN_PRODUCT_CODE)
            : false;
        const currentPath = typeof window !== "undefined"
            ? window.location.pathname
            : router.pathname;
        const unauthorizedPath = "/unauthorized";
        const accessRedirectPath = accessRedirect;
        if (!hasAppAccess &&
            !ignoreAccess &&
            currentPath !== unauthorizedPath &&
            currentPath !== accessRedirectPath) {
            const redirectTarget = accessRedirect !== null && accessRedirect !== void 0 ? accessRedirect : unauthorizedPath;
            window.location.replace(`${window.location.origin}${redirectTarget}`);
            return null;
        }
    }
    return _jsx(React.Fragment, { children: user && !isLoading && children });
};
